import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class ProjectTagService {
  constructor(private http: HttpClient) {}

  loadProjects(baseUrl: string, globalService: any, filterParams: any = {}, rowData: any = {}): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params: any = _.merge({}, globalService || {}, filterParams || {});
    params.action_id = 31;
    params.tax_year = rowData?.TAX_YEAR ?? params.tax_year;
    params.scenario = rowData?.SCENARIO ?? params.scenario;
    params.jcd_key = rowData?.JCD_KEY ?? params.jcd_key;
    return this.http.get<any>(url, { params, withCredentials: true });
  }

  loadProjectSteps(
    baseUrl: string,
    projectId: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params: any = _.merge({}, globalService || {}, filterParams || {});
    params.action_id = 32;
    params.project_id = projectId;
    params.tax_year = rowData?.TAX_YEAR ?? params.tax_year;
    params.scenario = rowData?.SCENARIO ?? params.scenario;
    params.jcd_key = rowData?.JCD_KEY ?? params.jcd_key;
    return this.http.get<any>(url, { params, withCredentials: true });
  }

  saveProjectTag(baseUrl: string, payload: any[], globalService: any, filterParams: any = {}, rowData: any = {}): Observable<any> {
    const url = `${baseUrl}/saveProjectTag`;
    const params: any = _.merge({}, globalService || {}, filterParams || {});
    params.jsonObj = JSON.stringify(payload || []);
    params.tax_year = rowData?.TAX_YEAR ?? params.tax_year;
    params.scenario = rowData?.SCENARIO ?? params.scenario;
    params.jcd_key = rowData?.JCD_KEY ?? params.jcd_key;

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach((key: string) => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
